// extracted by mini-css-extract-plugin
export default {"errorContainer":"NotFoundPage_errorContainer__u8Qjg","btn":"NotFoundPage_btn__PLDiK","text":"NotFoundPage_text__8DPwS"};